import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Button} from './CopyButton.style';

const CopyButton = ({text, label, compact, onCopy, className}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      if (onCopy) onCopy();

      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <Button
      onClick={handleCopy}
      copied={copied}
      compact={compact}
      className={className}
      title={`Copy ${label || 'text'}`}
    >
      <i className={copied ? 'mdi mdi-check' : 'mdi mdi-content-copy'} />
      {!compact && (copied ? 'Copied!' : label || 'Copy')}
    </Button>
  );
};

CopyButton.propTypes = {
  text: PropTypes.string.isRequired,
  label: PropTypes.string,
  compact: PropTypes.bool,
  onCopy: PropTypes.func,
  className: PropTypes.string,
};

export default CopyButton;
